import {fromJS, List} from 'immutable';

export default function (communityLessonPlans, filters) {
  const jsFilters = filters.toJS();

  // character filters
  const chosenCharacters = jsFilters.characters.filter(f => f.value).map(f => f.id);
  const keys = communityLessonPlans.keySeq();
  if (chosenCharacters.length) {
    keys.forEach(key => {
      communityLessonPlans = communityLessonPlans.update(key, values => {
        return values.filter(element => chosenCharacters.indexOf(element.get('characterName').toLowerCase()) >= 0);
      });
    });
  }

  // lesson type filters
  const chosenLessonTypes = jsFilters.lessonTypes.filter(f => f.value).map(f => f.name);
  if (chosenLessonTypes.length) {
    keys.forEach(key => {
      communityLessonPlans = communityLessonPlans.update(key, values => {
        return values.filter(element => chosenLessonTypes.indexOf(element.get('displayType')) >= 0);
      });
    });
  }

  // subject filters
  const chosenSubjects = jsFilters.subjects.filter(f => f.value).map(f => f.name);
  if (chosenSubjects.length) {
    keys.forEach(key => {
      communityLessonPlans = communityLessonPlans.update(key, values => {
        return values.filter(element => chosenSubjects.indexOf(element.get('subject')) >= 0);
      });
    });
  }


  return communityLessonPlans;
}



// WEBPACK FOOTER //
// ./app/features/community/services/communityLessonPlansFilterService.js